import ListadoDenuncia from './ListadoDenuncia';

export default ListadoDenuncia;
